import {
  type CompliancePolicy,
  toResponseError,
  type CompliancePolicyAddInput,
  type CompliancePolicyAddSuccess,
  type UnsavedCompliancePolicy,
} from '@terros/common'
import { mutationAdd, type AddHookResponse } from '../../hooks'
import { useTantalimMutation } from '../../mutation'
import { useCompliancePolicyCache } from './cache'

export function useAddCompliancePolicy(): AddHookResponse<UnsavedCompliancePolicy, CompliancePolicy> {
  const cache = useCompliancePolicyCache()
  const mutation = useTantalimMutation<CompliancePolicyAddInput, CompliancePolicyAddSuccess>({
    url: '/compliance/policy/add',
  })

  async function add(newPolicy: UnsavedCompliancePolicy): Promise<CompliancePolicy> {
    try {
      const { policy } = await mutation.mutateAsync({ policy: newPolicy })
      cache.addItem(policy)
      return policy
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
